import { date, number, object, string } from "yup";

export const transactionSchema = object({
  amount: number().required("Please enter Amount"),
  date: date().required("Please enter Date"),
  transaction_type: string().required("Please select Transaction type"),
  description: string().required("Please enter Description"),
});
